<template>
  <div>
    <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="Instituição">
            <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
            <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12">
            <!--
              BLOCO Z/W — o edital fala em USUÁRIOS do transporte, não só alunos. O tipo diz de
              qual cadastro a pessoa vem; a regra "exatamente um entre aluno e servidor" é
              validada no backend.
            -->
            <el-form-item label="Tipo de usuário" prop="tipo_usuario_id" key="tipo_usuario_id">
              <el-select v-model="dados.tipo_usuario_id" placeholder="Selecione" clearable
                         style="width:100%" @change="onTipoUsuario">
                <el-option v-for="t in tiposUsuario" :key="t.id"
                           :label="t.nome + (t.origem_pessoa === 'servidor' ? ' (servidor)' : ' (aluno)')"
                           :value="t.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8" v-if="origemAtual !== 'servidor'">
            <el-form-item label="Aluno" prop="aluno_id" key="aluno_id">
              <el-select v-model="dados.aluno_id" placeholder="pesquisar..." filterable remote clearable :remote-method="getAlunoByFilter" :loading="loadingAluno">
                <el-option v-for="a in alunos" :key="a.id" :label="a.nome" :value="a.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Rota" prop="rota_id" :rules="[$requiredChange]" key="rota_id">
              <el-select v-model="dados.rota_id" placeholder="pesquisar..." filterable remote clearable :remote-method="getRotaByFilter" :loading="loadingRota" @change="loadPontos">
                <el-option v-for="r in rotas" :key="r.id" :label="r.nome" :value="r.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Ponto (opcional)" prop="ponto_id" key="ponto_id">
              <el-select v-model="dados.ponto_id" placeholder="Selecione" clearable filterable>
                <el-option v-for="p in pontos" :key="p.id" :label="p.nome || ('#' + p.id)" :value="p.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
          </el-col>
          <el-col :xs="24" :sm="8" :md="8" v-if="origemAtual === 'servidor'">
            <!-- Itens 17 e 23 — o professor/servidor usuário do transporte. -->
            <el-form-item label="Servidor" prop="servidor_id" key="servidor_id">
              <el-select v-model="dados.servidor_id" placeholder="pesquisar..." filterable remote
                         clearable :remote-method="getServidorByFilter" :loading="loadingServidor"
                         style="width:100%">
                <el-option v-for="x in servidores" :key="x.id" :label="x.nome" :value="x.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <!--
              Itens 17 e 23 — "definir a(s) rota(s) por LOTAÇÃO FÍSICA". É o professor que
              atende três prédios e pega uma rota diferente em cada um.
            -->
            <el-form-item label="Lotação física (opcional)" prop="lotacao_fisica_id" key="lotacao_fisica_id">
              <el-select v-model="dados.lotacao_fisica_id" placeholder="Selecione" clearable
                         filterable style="width:100%">
                <el-option v-for="l in lotacoes" :key="l.id"
                           :label="l.nome + (l.tipo ? ' — ' + l.tipo : '')" :value="l.id"></el-option>
              </el-select>
              <small class="u-text-muted">Define a rota pelo prédio onde a pessoa atende.</small>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8" v-if="origemAtual !== 'servidor'">
            <!-- Item 12 — rota por matrícula: o aluno com duas matrículas pode ter rotas distintas. -->
            <el-form-item label="Matrícula (opcional)" prop="matricula_id" key="matricula_id">
              <el-select v-model="dados.matricula_id" placeholder="Selecione" clearable
                         filterable style="width:100%" :disabled="!dados.aluno_id">
                <el-option v-for="m in matriculas" :key="m.id"
                           :label="(m.num_matricula || ('#' + m.id)) + (m.turma ? ' — ' + m.turma : '')"
                           :value="m.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Turno" prop="turno" :rules="[$requiredChange]" key="turno">
              <el-select v-model="dados.turno">
                <el-option label="MANHÃ" value="manha"></el-option>
                <el-option label="TARDE" value="tarde"></el-option>
                <el-option label="NOITE" value="noite"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Ativo" prop="ativo" :rules="[$requiredChange]" key="ativo">
              <el-select v-model="dados.ativo">
                <el-option label="SIM" :value="true"></el-option>
                <el-option label="NÃO" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-aluno-transporte" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    tiposUsuario: [],
    servidores: [],
    lotacoes: [],
    matriculas: [],
    loadingServidor: false,
    edit: false,
    filtroInstituicao: { id: '', nome: '' },
    loadingAluno: false,
    alunos: [],
    loadingRota: false,
    rotas: [],
    pontos: [],
    dados: {
      id: '',
      instituicao_id: '',
      aluno_id: '',
      servidor_id: '',
      tipo_usuario_id: '',
      matricula_id: '',
      lotacao_fisica_id: '',
      rota_id: '',
      ponto_id: '',
      turno: 'manha',
      ativo: true
    }
  }),
  computed: {
    /** A origem manda no formulário: aluno some quando o tipo é de servidor, e vice-versa. */
    origemAtual () {
      const t = this.tiposUsuario.filter(x => String(x.id) === String(this.dados.tipo_usuario_id))[0]
      return t ? t.origem_pessoa : (this.dados.servidor_id ? 'servidor' : 'aluno')
    },

    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    this.carregarApoioW()
    this.restaurarInstituicaoDoQuery()
    if (this.$store.state.config.instituicao) {
      this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
  },
  methods: {
    /** Tipos de usuário e lotações físicas — o backend já recorta pelo escopo. */
    carregarApoioW () {
      const base = this.$store.state.config.baseUrlApi
      const h = this.$store.getters.getHeaderAuth

      this.$axios.post(`${base}/api/transporte-escolar/tipo-usuario/getAllPaginate`,
                       { per_page: 100, situacao: 1 }, h)
        .then(r => { this.tiposUsuario = (r.data && !r.data.erro) ? (r.data.data || []) : [] })
        .catch(() => {})

      this.$axios.post(`${base}/api/local-lotacao/getAllPaginate`, { per_page: 200 }, h)
        .then(r => { this.lotacoes = (r.data && !r.data.erro) ? (r.data.data || r.data || []) : [] })
        .catch(() => { this.lotacoes = [] })
    },

    /** Trocar o tipo limpa a pessoa do outro lado — não se guarda os dois. */
    onTipoUsuario () {
      if (this.origemAtual === 'servidor') {
        this.dados.aluno_id = ''
        this.dados.matricula_id = ''
      } else {
        this.dados.servidor_id = ''
      }
    },

    getServidorByFilter (query) {
      if (!query || query.length < 2) { this.servidores = []; return }
      this.loadingServidor = true

      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/servidor/searchByNome`,
                       { query }, this.$store.getters.getHeaderAuth)
        .then(r => {
          this.loadingServidor = false
          this.servidores = (r.data && !r.data.erro) ? (r.data.data || r.data || []) : []
        })
        .catch(() => { this.loadingServidor = false; this.servidores = [] })
    },

    restaurarInstituicaoDoQuery () {
      const qId = this.$route.query.instituicao_id
      if (!qId) return
      const atual = this.$store.state.config.instituicao
      if (atual && atual.id && String(atual.id) === String(qId)) return
      const lista = this.$store.state.instituicoes || []
      const fromList = Array.isArray(lista)
        ? lista.find(x => x && String(x.id) === String(qId))
        : (lista[qId] || null)
      const inst = fromList || { id: qId, nome: '' }
      this.$store.commit('setInstituicao', inst)
    },
    getAlunoByFilter (query) {
      if (!query || query.length < 4) { this.alunos = []; return }
      this.loadingAluno = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.alunos = JSON.parse(JSON.stringify(res.data)); this.loadingAluno = false })
        .catch(e => { this.loadingAluno = false; this.$store.commit('throwException', e) })
    },
    getRotaByFilter (query) {
      if (!query || query.length < 2) { this.rotas = []; return }
      this.loadingRota = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/rota/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.rotas = JSON.parse(JSON.stringify(res.data)); this.loadingRota = false })
        .catch(e => { this.loadingRota = false; this.$store.commit('throwException', e) })
    },
    async loadPontos () {
      this.pontos = []
      this.dados.ponto_id = ''
      if (!this.dados.rota_id) return
      const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/ponto/getAllPaginate`, { rota_id: this.dados.rota_id }, this.$store.getters.getHeaderAuth)
      this.pontos = (res.data && res.data.data) ? res.data.data : []
    },
    async getById (id) {
      const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/aluno/getById/` + id, this.$store.getters.getHeaderAuth)
      const data = JSON.parse(JSON.stringify(res.data))

      if (data && data.aluno) { this.alunos = [{ id: data.aluno.id, nome: data.aluno.nome }]; delete data.aluno }
      if (data && data.rota) { this.rotas = [{ id: data.rota.id, nome: data.rota.nome }]; delete data.rota }
      if (data && data.ponto) {
        this.pontos = [{ id: data.ponto.id, nome: data.ponto.nome }]
        delete data.ponto
      }

      this.dados = data
      if (this.dados.rota_id && (!this.pontos.length || (this.pontos.length === 1 && this.pontos[0].id === this.dados.ponto_id))) {
        await this.loadPontos()
        // garantir que o ponto atual apareça mesmo se não vier na primeira página
        if (this.dados.ponto_id && !this.pontos.find(p => p.id === this.dados.ponto_id)) {
          this.pontos.unshift({ id: this.dados.ponto_id, nome: '#' + this.dados.ponto_id })
        }
      }
    },
    onSubmit () {
      document.getElementById("btn-aluno-transporte").focus()
      this.$refs.dados.validate(async (valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        try {
          this.dados.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null
          if (this.edit) {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/aluno/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth)
          } else {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/aluno/store`, this.dados, this.$store.getters.getHeaderAuth)
          }
          window.eventBus.$emit('loading', false)
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$emit('onSubmitTransporteAluno')
        } catch (e) {
          window.eventBus.$emit('loading', false)
          this.$store.commit('throwException', e)
        }
      })
    }
  },
  watch: {
    paramId: {
      immediate: true,
      async handler (value) {
        if (value) {
          this.edit = true
          await this.getById(value)
        }
      }
    }
  }
}
</script>

